
<!--start section header-->
 
<header class="head">
    <div class="cover">
        <div class="container d-flex justify-content-center align-items-center pt-5">
         <div>
             <h2 class="pt-5">
                Gallery Fullwidth 2 columns
             </h2>
             <nav aria-label="breadcrumb">
                 <ol class="breadcrumb d-flex justify-content-center">
                   <li (click) = change() class="breadcrumb-item">
                       <a>Home</a>
                     </li>
                   <li class="breadcrumb-item active" aria-current="page">Gallery Fullwidth 2 columns</li>
                 </ol>
             </nav>
         </div>
 
        </div>
    </div>
 
 </header>
 
 <!--end section header-->

 <!--start section Gallery Fullwidth-->

 <section class="py-5 container gallery-fullwidth">
     <div class="pt-5">
         <ol class="list-unstyled d-flex justify-content-center py-4">
             <li (click) = "all()" class="pr-4">
                 All
             </li>
             <li  (click) = "medicall()" class="pr-4">
                 Medical
             </li>
             <li  (click) = "clinic()" class="pr-4">
                 Clinic
             </li>
             <li  (click) = "dental()" class="pr-4">
                 Dental
             </li>
             <li (click)="pharma()" class="pr-4">
                 Pharmacists
             </li>
         </ol>
     </div>
      <!--start section all-->
     <div id="all" class="row">

         <div class="col-lg-4 col-md-6 mb-2">
             <div class="cover">
                 <img src="assets/images/b.jpg" class="w-100" alt="drugs">
                 <i class="fas fa-search icons"></i>
                 <div class="cover-bg"></div>
             </div>
             <div class="text-center cover-footer">
                 <ul class="list-unstyled pt-3">
                     <li class="p1">Medical</li>
                     <li class="p2">Morbi euismod</li>
                 </ul>
             </div>
         </div>
         <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/e.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Clinic</li>
                    <li class="p2">Vestibulum libero</li>
                </ul>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/h.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Dental</li>
                    <li class="p2">Pellentesque commodo</li>
                </ul>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/m.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Pharmacists</li>
                    <li class="p2">Lorem ipsum</li>
                </ul>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/i.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Medical</li>
                    <li class="p2">Sarmiento museum</li>
                </ul>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/w.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Clinic</li>
                    <li class="p2">Proin imperdiet</li>
                </ul>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/100.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Dental</li>
                    <li class="p2">Aenean varius</li>
                </ul>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/r.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Pharmacists</li>
                    <li class="p2">Praesent eleifend</li>
                </ul>
            </div>
        </div>

     </div>
      <!--end section all-->

     <!--start section medical-->
     <div id="medicall" class="row">

        <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/b.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Medical</li>
                    <li class="p2">Morbi euismod</li>
                </ul>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-2">
           <div class="cover">
               <img src="assets/images/i.jpg" class="w-100" alt="drugs">
               <i class="fas fa-search icons"></i>
               <div class="cover-bg"></div>
           </div>
           <div class="text-center cover-footer">
               <ul class="list-unstyled pt-3">
                   <li class="p1">Medical</li>
                   <li class="p2">Sarmiento museum</li>
               </ul>
           </div>
       </div>

     </div>
     <!--end section medical-->

      <!--start section Clinic-->
      <div id="clinic" class="row">

        <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/e.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Clinic</li>
                    <li class="p2">Vestibulum libero</li>
                </ul>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/w.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Clinic</li>
                    <li class="p2">Proin imperdiet</li>
                </ul>
            </div>
        </div>


        

     </div>
     <!--end section Clinic-->

      <!--start section dental-->
      <div id="dental" class="row">

        <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/h.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Dental</li>
                    <li class="p2">Pellentesque commodo</li>
                </ul>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/100.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Dental</li>
                    <li class="p2">Aenean varius</li>
                </ul>
            </div>
        </div>

        
        


        

      </div>
     <!--end section dental-->

     <!--start section Pharmacists-->
     <div id="pharmacists" class="row">

        <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/m.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Pharmacists</li>
                    <li class="p2">Lorem ipsum</li>
                </ul>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-2">
            <div class="cover">
                <img src="assets/images/b.jpg" class="w-100" alt="drugs">
                <i class="fas fa-search icons"></i>
                <div class="cover-bg"></div>
            </div>
            <div class="text-center cover-footer">
                <ul class="list-unstyled pt-3">
                    <li class="p1">Medical</li>
                    <li class="p2">Morbi euismod</li>
                </ul>
            </div>
        </div>

      </div>
     <!--end section Pharmacists-->
 </section>



  <!--end section Gallery Fullwidth-->